import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// import vuetify from "vuetify";
import * as VueGoogleMaps from "vue2-google-maps-withscopedautocomp";
import VueYouTubeEmbed from "vue-youtube-embed";

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyArM-iGlbjzogETAFSIU46b2UoOgxvtkoU",
    libraries: "places"
  },
  installComponents: true
});
Vue.use(VueYouTubeEmbed);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
